<div class="seo-issues-btn-group">
    <div class="btn-group" ngbDropdown [style.width]="btnGroupWidth()">
        <a class="btn btn-border-radius btn-orange btn-sm btn-sand text-left cursor-pointer" ngbDropdownToggle>
            <span class="fas fa-chevron-down pull-right"></span>
            <span class="sr-only pull-right outer-t-smurf" translate>Toggle dropdown</span>
        </a>
        <ul class="dropdown-menu pull-right" ngbDropdownMenu role="menu">
            <ng-content></ng-content>
        </ul>
        <span class="counter outer-l-small outer-t-mini pull-right">{{ count | monNumber }}</span>
    </div>
</div>
